var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Total Blocks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography-/-Total-Blocks",
    fill: "#063C4F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 L32,48 L0,48 L0,16 L32,16 Z M29,19 L3,19 L3,45 L29,45 L29,19 Z M40,8 L40,40 L36.952381,40 L36.952381,11.047619 L8,11.047619 L8,8 L40,8 Z M23,25 L23,39 L20.0527284,39 L20.0527284,30.031227 L11.1465146,38.9374409 L9.06255914,36.8531174 L17.968773,27.9472716 L9,27.9472716 L9,25 L23,25 Z M48,0 L48,32 L44.952381,32 L44.952381,3.04761905 L16,3.04761905 L16,0 L48,0 Z",
    id: "Total-Blocks"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBlocks);
export default __webpack_public_path__ + "static/media/TotalBlocks.601cf573875cbceff7d9ee919540aacb.svg";
export { ForwardRef as ReactComponent };